add:
    en: Add
    es: Añadir
    fr: Ajouter
    pt: Adicionar
    ru: Создать
delete:
    en: Delete
    es: Borrar
    fr: Supprimer
    pt: Apagar
    ru: Удалить
save:
    en: Save
    es: Guardar
    fr: Enregistrer
    pt: Guardar
    ru: Сохранить
dontSave:
    en: "Don't save"
    es: 'No guardar'
    pt: 'Não guardar'
    ru: 'Не сохранять'
saveForDay: 
    en: Save for chosen day
    es: Guardar para el día elegido
    fr: Enregistrer pour le jour choisi
    pt: Guardar para o dia escolhido
    ru: Сохранить на выбранный день
saveForToday: 
    en: Save for today
    es: Guardar para hoy
    fr: Enregistrer pour aujourd'hui
    pt: Guardar para hoje
    ru: Сохранить на сегодня
updateDefaults:
    en: Update defaults
    es: Actualizar por defecto
    fr: Mettre à jour les valeurs par défaut
    pt: Atualizar padrões
    ru: Обновить значения по умолчанию
saved: 
    en: Saved
    es: Guardado
    fr: Sauvegardé
    pt: Salvo
    ru: Сохранено
back:
    ru: Возврат
    en: Back
    fr: Retour
    pt: Voltar
    es: Volver
next: 
    ru: Далее
    en: Next
    fr: Suivant
    pt: Próximo
    es: Siguiente
export:
    en: Export
    es: Exportación
    fr: Exporter
    pt: Exportar
    ru: Экспорт
saveAndUpdate:
    en: 'Save and update defaults'
    da: 'Save and update defaults'
    es: 'Guardar & actualizar por defecto'
    fr: 'Enregistrer et mettre à jour les valeurs par défaut'
    pt: 'Guardar & Atualizar'
    ru: 'Сохранить и обновить значения по умолчанию'
saveAndClone:
    en: 'Save and clone'
    es: 'Guardar y clonar'
    fr: 'Sauvegarder et dupliquer'
    pt: 'Guardar & Copiar'
    ru: 'Сохранить и клонировать'
saveAndContinue:
    en: 'Save and continue'
    es: 'Guardar y continuar'
    fr: 'Sauvegarder et continuer'
    pt: 'Guardar & Continuar'
    ru: 'Сохранить и продолжить'
cancel:
    en: Cancel
    es: Cancelar
    fr: Supprimer
    pt: Cancelar
    ru: Отмена
discard:
    en: Discard
    es: Descartar
    fr: Annuler
    pt: Desfazer
    ru: Отменить
confirmation:
    ru: Подтверждение
    en: Confirmation
    fr: Confirmation
    pt: Confirmação
    es: Confirmación
continue:
    ru: Продолжить
    en: Continue
    pt: Continuar
    es: Continuar
finish:
    en: Finish
    es: Finalizar
    fr: Terminer
    pt: Terminar
    ru: Завершить
skip:
    en: Skip
    es: Omitir
    fr: Ignorer
    pt: Ignorar
    ru: Пропустить
yes:
    en: Yes
    es: Si
    fr: Oui
    pt: Sim
    ru: Да
no:
    en: No
    es: No
    fr: Non
    pt: Não
    ru: Нет
ok:
    en: Ok
    es: Aceptar
    fr: Ok
    pt: Ok
    ru: Продолжить
information:
    en: Information
    es: Información
    fr: Informations
    pt: Informação
    ru: Уведомление
error:
    en: Error
    es: Error
    fr: Erreur
    pt: Erro
    ru: Ошибка
warning:
    en: Warning
    es: Aviso
    fr: Attention
    pt: Aviso
    ru: Внимание
progressBar:
    en: 'Progress bar'
    es: 'Barra de progreso'
    fr: 'Barre de progression'
    pt: 'Barra de progresso'
    ru: Прогресс
import:
    en: Import
    es: Importación
    fr: Import
    pt: Importar
    ru: Импорт
addGroup:
    en: 'Add group'
    es: 'Añadir grupo'
    fr: 'Ajouter groupe'
    pt: 'Adicionar grupo'
    ru: 'Добавить группу'
edit:
    en: Edit
    es: Editar
    fr: Modifier
    pt: Editar
    ru: Изменить
new:
    en: New
    es: Nuevo
    fr: Nouveau
    pt: Novo
    ru: Новый
create:
    en: Create
    es: Crear
    fr: Créer
    pt: Criar
    ru: Создание
update:
    en: Update
    es: Actualizar
    fr: 'Mettre à jour'
    pt: Atualizar
    ru: Изменение
clone:
    en: Clone
    es: Clonar
    fr: Dupliquer
    pt: Copiar
    ru: Клонировать
apply:
    en: Apply
    es: Aplicar
    fr: Appliquer
    pt: Aplicar
    ru: Применить
reset:
    en: Reset
    es: Resetear
    fr: Relancer
    pt: Reiniciar
    ru: Сбросить
search:
    en: Search
    es: Búsqueda
    fr: Recherche
    pt: Pesquisar
    ru: Поиск
close:
    en: Close
    es: Cerrar
    fr: Fermer
    pt: Fechar
    ru: Закрыть
settings:
    ru: Настройки
    en: Settings
    fr: 'Paramètres'
    pt: Definições
    es: Parametros
printButtonTitle:
    ru: Печать
    en: Print
    fr: Imprimer
    pt: Imprimir
    es: Imprimir
chooseColor:
    ru: 'Выберете цвет'
    en: 'Choose color'
    pt: 'Escolha a cor'
    es: 'Elegir color'
    fr: 'Choisissez une couleur'
of:
    en: '{0} of {1}'
    ru: '{0} из {1}'
    es: '{0} de {1}'
    pt: '{0} de {1}'
    fr: '{0} of {1}'
doYouWantToLeave:
    en: 'Do you want to close the form without saving changes?'
    es: '¿Quieres salir la edición de filas sin guarder los cambios?'
    pt: 'Quer fechar o formulário sem guarder as mudanças?'
    ru: 'Закрыть форму без сохранения изменений?'
    fr: 'Voulez-vous fermer le formulaire sans enregistrer les modifications?'
doYouWantToLeaveWithSave:
    en: 'Do you want to save the changes?'
    es: 'Desea guardar los cambios?'
    pt: 'Quer salvar as alterações?'
    ru: 'Сохранить изменения?'
yesClose:
    en: 'Yes, close'
    es: 'Si, cerrar'
    pt: 'Sim, fechar'
    ru: 'Да, закрыть'
appliesTo: 
    en: 'Applies to'
    es: 'Aplica a'
    fr: "S'applique à"
    pt: 'Aplica-se a'
    ru: 'Применяется к'
copyTo: 
    en: 'Copy to'
    es: 'Copiar a'
    fr: 'Copier à'
    pt: 'Copiar para'
    ru: 'Копировать в'
